
export const useStoriesWrapper = () => {
  const logger = useFrontendLogger()
  /**
   * Init CncAddWrapper
   */
  const init = () => {
    const runtimeConfig = useRuntimeConfig()
    const storiesConfig = runtimeConfig.public.storiesWrapper
    if (storiesConfig?.enabled) {
      logger?.info('StoriesWrapper ENABLED')

      if (!storiesConfig.scripts) {
        logger?.warn(`StoriesWrapper ENABLED but 'config.public.storiesWrapper.scripts' missing`)
        return
      }

      if (!storiesConfig.iframeSrc) {
        logger?.warn(`StoriesWrapper ENABLED but 'config.public.storiesConfig.iframeSrc' missing`)
        return
      }

      const script = []
      for (let i in storiesConfig.scripts) {
        const scriptItem: Record<string, any> = storiesConfig.scripts[i]
        script.push({
          src: scriptItem.src,
          id: scriptItem.id,
          type: "application/javascript",
          async: scriptItem.async,
          fetchpriority: scriptItem.fetchpriority,
          referrerpolicy: scriptItem.referrerpolicy,
        })
      }

      if (import.meta.client && window) {
        useHead({
          script
        })
      }
    }
  }

  /**
   * Get position config for given position and page
   * @return {any}
   */
  const getIframeSrc = (): string => {
    const runtimeConfig = useRuntimeConfig()
    const storiesConfig = runtimeConfig.public.storiesWrapper

    return storiesConfig.iframeSrc
  }

  const isEnabled = (): boolean => {
    const runtimeConfig = useRuntimeConfig()
    const storiesConfig = runtimeConfig.public.storiesWrapper

    return storiesConfig.enabled || false
  }

  return {
    init,
    getIframeSrc,
    isEnabled,
  }
}


